//------------ REACT IMPORT --------------//
import React from "react";
//--------- BOOTSTRAP ITEMS IMPORT ----------//
import { Col, Image, Row } from "react-bootstrap";
import { LogCalendar, LogsImg } from "../../../../assets/images";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PaginationComponent from "../../CommanComponents/Pagination";


const Logs = () => {

    return (
        <>
            <div className="logs_tab_screen">
                <Row>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <div className="main_log">
                            <div className="title_area">
                                <div className="left_title">
                                    <p>Total Logs : 54</p>
                                </div>
                                <div className="right_title">
                                    <p>Today</p>
                                    <div className="icon">
                                        <Image src={LogCalendar} alt="..." />
                                    </div>
                                </div>
                            </div>
                            <div className="date_area">
                                <p>12 June, 2023</p>
                            </div>
                            <div className="main_area">
                                <div className="left_area">
                                    <p>06:00 PM</p>
                                    <div className="check_icon">
                                        <FontAwesomeIcon icon={faCircleCheck} />
                                    </div>
                                </div>
                                <div className="right_area">
                                    <div className="inner_left_area">
                                        <div className="left_img_area">
                                            <div className="img_area">
                                                <Image src={LogsImg} alt="..." />
                                            </div>
                                        </div>
                                        <div className="right_name_area">
                                            <p className="label">Genevieve Hart</p>
                                            <p><span>Nurse</span></p>
                                        </div>
                                    </div>
                                    <div className="inner_right_area">
                                        <p><span>Complete Todays Task</span></p>
                                        <p>Brief description about which task is complete</p>
                                    </div>
                                </div>
                            </div>
                            <div className="main_area">
                                <div className="left_area">
                                    <p>05:00 PM</p>
                                    <div className="check_icon">
                                        <FontAwesomeIcon icon={faCircleCheck} />
                                    </div>
                                </div>

                                <div className="right_area">
                                    <div className="inner_left_area">
                                        <div className="left_img_area">
                                            <div className="img_area">
                                                <Image src={LogsImg} alt="..." />
                                            </div>
                                        </div>
                                        <div className="right_name_area">
                                            <p className="label">Genevieve Hart</p>
                                            <p><span>Nurse</span></p>
                                        </div>
                                    </div>
                                    <div className="inner_right_area">
                                        <p><span>Complete Todays Task</span></p>
                                        <p>Brief description about which task is complete</p>
                                    </div>
                                </div>
                            </div>
                            <div className="main_area">
                                <div className="left_area">
                                    <p>04:00 PM</p>
                                    <div className="check_icon">
                                        <FontAwesomeIcon icon={faCircleCheck} />
                                    </div>
                                </div>

                                <div className="right_area">
                                    <div className="inner_left_area">
                                        <div className="left_img_area">
                                            <div className="img_area">
                                                <Image src={LogsImg} alt="..." />
                                            </div>
                                        </div>
                                        <div className="right_name_area">
                                            <p className="label">Genevieve Hart</p>
                                            <p><span>Nurse</span></p>
                                        </div>
                                    </div>
                                    <div className="inner_right_area">
                                        <p><span>Complete Todays Task</span></p>
                                        <p>Brief description about which task is complete</p>
                                    </div>
                                </div>
                            </div>
                            <div className="main_area">
                                <div className="left_area">
                                    <p>03:00 PM</p>
                                    <div className="check_icon">
                                        <FontAwesomeIcon icon={faCircleCheck} />
                                    </div>
                                </div>

                                <div className="right_area">
                                    <div className="inner_left_area">
                                        <div className="left_img_area">
                                            <div className="img_area">
                                                <Image src={LogsImg} alt="..." />
                                            </div>
                                        </div>
                                        <div className="right_name_area">
                                            <p className="label">Genevieve Hart</p>
                                            <p><span>Nurse</span></p>
                                        </div>
                                    </div>
                                    <div className="inner_right_area">
                                        <p><span>Complete Todays Task</span></p>
                                        <p>Brief description about which task is complete</p>
                                    </div>
                                </div>
                            </div>
                            <div className="main_area">
                                <div className="left_area">
                                    <p>02:00 PM</p>
                                    <div className="check_icon">
                                        <FontAwesomeIcon icon={faCircleCheck} />
                                    </div>
                                </div>

                                <div className="right_area">
                                    <div className="inner_left_area">
                                        <div className="left_img_area">
                                            <div className="img_area">
                                                <Image src={LogsImg} alt="..." />
                                            </div>
                                        </div>
                                        <div className="right_name_area">
                                            <p className="label">Genevieve Hart</p>
                                            <p><span>Nurse</span></p>
                                        </div>
                                    </div>
                                    <div className="inner_right_area">
                                        <p><span>Complete Todays Task</span></p>
                                        <p>Brief description about which task is complete</p>
                                    </div>
                                </div>
                            </div>
                            <div className="main_area">
                                <div className="left_area">
                                    <p>01:00 PM</p>
                                    <div className="check_icon">
                                        <FontAwesomeIcon icon={faCircleCheck} />
                                    </div>
                                </div>

                                <div className="right_area">
                                    <div className="inner_left_area">
                                        <div className="left_img_area">
                                            <div className="img_area">
                                                <Image src={LogsImg} alt="..." />
                                            </div>
                                        </div>
                                        <div className="right_name_area">
                                            <p className="label">Genevieve Hart</p>
                                            <p><span>Nurse</span></p>
                                        </div>
                                    </div>
                                    <div className="inner_right_area">
                                        <p><span>Complete Todays Task</span></p>
                                        <p>Brief description about which task is complete</p>
                                    </div>
                                </div>
                            </div>
                            <div className="main_area">
                                <div className="left_area">
                                    <p>12:00 AM</p>
                                    <div className="check_icon">
                                        <FontAwesomeIcon icon={faCircleCheck} />
                                    </div>
                                </div>

                                <div className="right_area">
                                    <div className="inner_left_area">
                                        <div className="left_img_area">
                                            <div className="img_area">
                                                <Image src={LogsImg} alt="..." />
                                            </div>
                                        </div>
                                        <div className="right_name_area">
                                            <p className="label">Genevieve Hart</p>
                                            <p><span>Nurse</span></p>
                                        </div>
                                    </div>
                                    <div className="inner_right_area">
                                        <p><span>Complete Todays Task</span></p>
                                        <p>Brief description about which task is complete</p>
                                    </div>
                                </div>
                            </div>
                            <div className="main_area">
                                <div className="left_area">
                                    <p>11:00 AM</p>
                                    <div className="check_icon">
                                        <FontAwesomeIcon icon={faCircleCheck} />
                                    </div>
                                </div>

                                <div className="right_area">
                                    <div className="inner_left_area">
                                        <div className="left_img_area">
                                            <div className="img_area">
                                                <Image src={LogsImg} alt="..." />
                                            </div>
                                        </div>
                                        <div className="right_name_area">
                                            <p className="label">Genevieve Hart</p>
                                            <p><span>Nurse</span></p>
                                        </div>
                                    </div>
                                    <div className="inner_right_area">
                                        <p><span>Complete Todays Task</span></p>
                                        <p>Brief description about which task is complete</p>
                                    </div>
                                </div>
                            </div>
                            <div className="main_area">
                                <div className="left_area">
                                    <p>10:00 AM</p>
                                    <div className="check_icon">
                                        <FontAwesomeIcon icon={faCircleCheck} />
                                    </div>
                                </div>

                                <div className="right_area">
                                    <div className="inner_left_area">
                                        <div className="left_img_area">
                                            <div className="img_area">
                                                <Image src={LogsImg} alt="..." />
                                            </div>
                                        </div>
                                        <div className="right_name_area">
                                            <p className="label">Genevieve Hart</p>
                                            <p><span>Nurse</span></p>
                                        </div>
                                    </div>
                                    <div className="inner_right_area">
                                        <p><span>Complete Todays Task</span></p>
                                        <p>Brief description about which task is complete</p>
                                    </div>
                                </div>
                            </div>
                            <div className="main_area">
                                <div className="left_area">
                                    <p>09:00 AM</p>
                                    <div className="check_icon">
                                        <FontAwesomeIcon icon={faCircleCheck} />
                                    </div>
                                </div>

                                <div className="right_area">
                                    <div className="inner_left_area">
                                        <div className="left_img_area">
                                            <div className="img_area">
                                                <Image src={LogsImg} alt="..." />
                                            </div>
                                        </div>
                                        <div className="right_name_area">
                                            <p className="label">Genevieve Hart</p>
                                            <p><span>Nurse</span></p>
                                        </div>
                                    </div>
                                    <div className="inner_right_area">
                                        <p><span>Complete Todays Task</span></p>
                                        <p>Brief description about which task is complete</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </Col>
                </Row>

            </div>
            <PaginationComponent />
        </>
    )
}

export default Logs;